import { render, staticRenderFns } from "./child.vue?vue&type=template&id=2e040791"
import script from "./child.vue?vue&type=script&lang=js"
export * from "./child.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e040791')) {
      api.createRecord('2e040791', component.options)
    } else {
      api.reload('2e040791', component.options)
    }
    module.hot.accept("./child.vue?vue&type=template&id=2e040791", function () {
      api.rerender('2e040791', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/child.vue"
export default component.exports